interface Params<T> {
  value: T;
  defaultValue: T;
  predicate: (value: T) => boolean;
}

export default function defaultValue<T>({
  value,
  defaultValue,
  predicate,
}: Params<T>) {
  return predicate(value) ? value : defaultValue;
}
